<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="车牌名称">
          <el-input placeholder="请输入车牌名称" v-model="formInline.search">

          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>

          <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button>

        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加车牌</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>

            <el-table-column prop="name" label="车牌名称"></el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :car_number_id="car_number_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
                :close-on-click-modal="false"
                :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

  </div>
</template>

<script>
import Car_numberApi from '@/api/car_number.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';

export default {
  components: {
    Add,
    Edit,
    Import,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search:""
      },

      open_add:false,
      open_edit:false,
      car_number_id:"",
      dialogVisible:false,
      open_import:false,
      /*选中的*/
      selection: [],
      selectedRows: [], // 选中的行数据
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {
    dialogFormVisible(){
      this.dialogVisible = false;
    },
    setting(e){//车牌标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /* 多选框选择变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /* 清空选择 */
    clearSelection() {
      if (this.multipleTable) {
        this.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList(); // 导入成功后刷新列表
      }
    },
    importClick() {
      this.open_import = true;
    },
    exportData() {
      // 构建导出参数
      let exportParams = {
        name: this.formInline.name,
      };

      // 如果有选中的数据，添加选中的ID；否则导出全部（不传selected_ids参数）
      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.dz_spec_id);
        exportParams.selected_ids = selectedIds.join(',');
      }

      // 使用页面跳转方式导出，避免blob处理
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
          .filter(key => exportParams[key] !== '')
          .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
          .join('&');

      window.location.href = baseUrl + '/index.php/shop/plus.car_number.Index/export?' + queryString;
    },
    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Car_numberApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true
    },

    /*编辑活动*/
    editClick(row) {
      this.car_number_id = row.car_number_id;
      this.open_edit = true
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Car_numberApi.del(
                {
                  car_number_id: row.car_number_id
                },
                true
            )
                .then(data => {
                  if (data.code == 1) {
                    self.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.getTableList();
                  } else {
                    self.$message.error('错了哦，这是一条错误消息');
                  }
                })
                .catch(error => {
                });
          })
          .catch(() => {
          });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/car_number/index/index.vue